import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import momencik from '../../../common/momencik';
import numberFormatter from '../../../common/numberFormatter';
import { GetPricingDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';

interface PricingGridProps {
  getData: GridGetterFunction;
  getCount: (filterText?: string) => Promise<number>;
  refresh?: boolean;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
}

export const pricingForGrid = (pricingGrid: GetPricingDto) => {
  return {
    key: pricingGrid.id,
    values: {
      'pricing.name': pricingGrid.name || 'Bez nazwy',
      'pricing.startDate': momencik(pricingGrid.startDate),
      'pricing.endDate': momencik(pricingGrid.endDate) || '-',
      'pricing.percentageDiscount': pricingGrid.percentageDiscount
        ? numberFormatter(pricingGrid.percentageDiscount)
        : '-',
      'company.name': pricingGrid.company?.name || '-',
    },
  };
};

export const Pricing: React.FC<PricingGridProps> = props => {
  const columns = [
    { header: 'Nazwa', property: 'pricing.name' },
    { header: 'Firma', property: 'company.name' },
    { header: 'Data rozpoczęcia', property: 'pricing.startDate' },
    { header: 'Data zakończenia', property: 'pricing.endDate' },
    { header: 'Rabat %', property: 'pricing.percentageDiscount' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="pricing.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak cenników w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      onRowClick={props.onRowClick}
    />
  );
};
